import { Switch as SwitchPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/lib/utils'

function Switch({
    className,
    size = 'default',
    ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
    size?: 'sm' | 'default'
}) {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            data-size={size}
            className={cn(
                'peer group/switch inline-flex',
                'shrink-0 items-center rounded-full',
                'border border-transparent shadow-xs',
                'transition-all outline-none',
                'focus-visible:border-ring',
                'focus-visible:ring-[3px] focus-visible:ring-ring/50',
                'disabled:cursor-not-allowed',
                'disabled:opacity-disabled',
                'data-[size=default]:h-6 data-[size=default]:w-11',
                'data-[size=sm]:h-[1.125rem] data-[size=sm]:w-8',
                'data-[state=checked]:bg-primary',
                'data-[state=unchecked]:bg-ring/80 dark:data-[state=unchecked]:bg-input/80',
                'hover:not-[disabled]:ring-2 ring-ring',
                className,
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className={cn(
                    'pointer-events-none block rounded-full',
                    'bg-background ring-0 transition-transform',
                    'group-data-[size=default]/switch:size-[1.3rem]',
                    'group-data-[size=sm]/switch:size-4',
                    'data-[state=checked]:translate-x-[calc(100%-2px)]',
                    'data-[state=unchecked]:translate-x-0',
                    'dark:data-[state=checked]:bg-primary-foreground',
                    'dark:data-[state=unchecked]:bg-foreground',
                )}
            />
        </SwitchPrimitive.Root>
    )
}

export { Switch }
